import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import { jsx as _jsx } from "react/jsx-runtime";
export const filterAndAddDividerBetweenGroups = dropdownActionGroups => {
  return dropdownActionGroups.map(actionGroup => actionGroup.filter(Boolean)) // Remove null buttons
  .filter(actionGroup => actionGroup.length > 0) // Remove empty groups
  .flatMap((value, index, array) => {
    // Insert divider between each group
    return array.length - 1 !== index ? [value, /*#__PURE__*/_jsx(UIDropdownDivider, {
      "data-test-id": "action-divider"
    }, index)] : [value];
  }).flat();
};